import { Bell, Menu, Search } from 'lucide-react';
import React from 'react';
import { Box, Button, Flex, Text } from 'theme-ui';

interface HeaderProps {
  onMenuClick?: () => void;
  onNotificationClick?: () => void;
  onSearchClick?: () => void;
  children: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  onMenuClick,
  onNotificationClick,
  onSearchClick,
  children,
}) => {
  return (
    <Box
      as="header"
      sx={{
        width: '100%',
        backgroundColor: 'background',
        padding: '8px 16px',
      }}
    >
      <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Flex sx={{ alignItems: 'center', gap: 3 }}>
          <Button
            variant="icon"
            onClick={onMenuClick}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Menu size={24} />
          </Button>
          <Text sx={{ fontSize: 3, fontWeight: 'bold' }}>{children}</Text>
        </Flex>

        <Flex sx={{ gap: 2 }}>
          <Button
            variant="icon"
            onClick={onNotificationClick}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Bell size={24} />
          </Button>
          <Button
            variant="icon"
            onClick={onSearchClick}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Search size={24} />
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
